<template>
<div class="suggestion-bounty">
    <span ref="tippyRef" class="icon">
        <!-- @click doesn't work when bounty icon is animating. Use @mousedown -->
        <BountyIconSymbolRef/>
    </span>
    <BountyModal ref="modal" :suggestion="suggestion"/>
    <div v-if="bounties.length" class="bounty-amount">
        {{ totalAmount | bigNumber }}
    </div>
    <div v-show="false"><!-- Hide tippy initially -->
        <BountyLeaderboard ref="tippyContent" :suggestion="suggestion">
            <a @click="openModal">
                Show Support
            </a>
        </BountyLeaderboard>
    </div>
</div>
</template>

<script>
import tippy from '@/tippy'
import BountyModal from './BountyModal'
import BountyIconSymbolRef from './BountyIconSymbolRef'
import BountyLeaderboard from './BountyLeaderboard'

export default {
    name: 'SuggestionBounty',
    props: {
        suggestion: Object,
    },
    data: () => ({
        showAll: false,
    }),
    computed: {
        bounties: vm => vm.suggestion.bounties,
        totalAmount: vm => vm.bounties.reduce((memo, b) => b.totalAmount + memo, 0),
    },
    mounted () {
        const $refs = this.$refs
        this.tippyInstance = tippy($refs.tippyRef, {
            content: ref => $refs.tippyContent.$el,
            interactive: true,
            appendTo: document.body,
            placement: 'bottom',
            onCreate (instance) {
                instance.popper.classList.add('scrollable')
            },
            //hideOnClick: false,
            //trigger: 'click', // DEBUG ONLY
        })

        this.$once('hook:destroyed', this.tippyInstance.destroy)
    },
    methods: {
        openModal () {
            this.tippyInstance.hide()
            this.$refs.modal.open()
        }
    },
    components: {
        BountyIconSymbolRef,
        BountyModal,
        BountyLeaderboard,
    }
}
</script>

<style lang="scss" scoped>
.suggestion-bounty {
    @include flex-center-children;
    margin-right: 6px;
}

svg.bounty-icon-symbol-ref {
    transform: translateY(1px);
}

.bounty-amount {
    @include flex-center-children;
    cursor: default;
    font-size: 0.75rem;
}

</style>
